import React, { useState } from "react";
import { db } from "../firebase";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ar } from "date-fns/locale";
import { motion } from "framer-motion";

registerLocale("ar", ar);

const Hagz = () => {
  const [date, setDate] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  // ✅ تعديل أوقات وأيام الحجز
  const isValidDate = (selectedDate) => {
    if (!selectedDate) return false;
    const day = selectedDate.getDay(); // 0=الأحد, 5=الجمعة, 6=السبت
    const hours = selectedDate.getHours();

    // ✅ الحجز متاح من السبت (6) إلى الأربعاء (3)
    if (day === 4 || day === 5) {
      setError("❌ الحجز غير متاح يومي الخميس أو الجمعة");
      return false;
    }

    // ✅ الحجز من 5 مساءً إلى 10 مساءً فقط
    if (hours < 17 || hours >= 22) {
      setError("❌ الحجز متاح من الساعة 5 مساءً حتى 10 مساءً فقط");
      return false;
    }

    setError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !phone || !date) {
      setError("❌ من فضلك ادخل كل البيانات بشكل صحيح");
      return;
    }
    if (!isValidDate(date)) return;

    try {
      await db.collection("appointments").add({
        name,
        phone,
        date: date.toISOString(),
        createdAt: new Date(),
      });
      alert("✅ تم تسجيل الحجز بنجاح");
      setName("");
      setPhone("");
      setDate(null);
      setError("");
    } catch (error) {
      console.error("خطأ في التسجيل:", error);
      setError("❌ حدث خطأ أثناء التسجيل");
    }
  };

  return (
    <section
      style={{
        position: "relative",
        background: "linear-gradient(135deg, #133015, #1e1e1e)",
        color: "#fff",
        padding: "80px 0",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-150px",
          left: "-100px",
          width: "400px",
          height: "400px",
          background: "rgba(159, 216, 122, 0.1)",
          borderRadius: "50%",
          filter: "blur(60px)",
        }}
      ></div>

      <div
        style={{
          width: "90%",
          maxWidth: "1100px",
          margin: "0 auto",
          position: "relative",
          zIndex: 2,
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          style={{
            textAlign: "center",
            marginBottom: "50px",
          }}
        >
          <h2
            style={{
              fontSize: "2.2rem",
              fontWeight: "bold",
              color: "#9fd87a",
              marginBottom: "10px",
            }}
          >
            احجز موعدك الآن
          </h2>
          <p style={{ color: "#ddd", fontSize: "1rem" }}>
            اختر التاريخ المناسب وسنقوم بالتأكيد معك فورًا.
          </p>
        </motion.div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "40px",
          }}
        >
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            style={{
              flex: "1 1 300px",
              textAlign: "center",
            }}
          >
            <img
              src="https://res.cloudinary.com/defcamc5x/image/upload/v1761944550/jr3a9kh2cncjz7nba9x2.png"
              alt="حجز موعد"
              style={{
                maxWidth: "90%",
                borderRadius: "16px",
                margin: "auto",
              }}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            style={{
              flex: "1 1 350px",
              background: "rgba(255, 255, 255, 0.08)",
              padding: "30px 25px",
              borderRadius: "16px",
              backdropFilter: "blur(6px)",
              boxShadow: "0 4px 25px rgba(0, 0, 0, 0.2)",
            }}
          >
            <form
              onSubmit={handleSubmit}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              {error && (
                <p style={{ color: "#ff6b6b", textAlign: "center" }}>{error}</p>
              )}

              <label style={{ fontWeight: 600, fontSize: "16px" }}>
                الاسم بالكامل
              </label>
              <input
                type="text"
                placeholder="ادخل اسمك"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #555",
                  background: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  fontSize: "15px",
                  width: "100%",
                }}
              />

              <label style={{ fontWeight: 600, fontSize: "16px" }}>
                رقم الهاتف
              </label>
              <input
                type="text"
                placeholder="ادخل رقمك"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                style={{
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #555",
                  background: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  fontSize: "15px",
                  width: "100%",
                }}
              />

              <label style={{ fontWeight: "600" }}>تاريخ الزيارة:</label>
              <div style={{ position: "relative" }}>
                <DatePicker
                  selected={date}
                  onChange={(d) => setDate(d)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={30}
                  dateFormat="yyyy-MM-dd HH:mm"
                  placeholderText="اختر موعد الزيارة"
                  // ✅ الحجز متاح من السبت (6) إلى الأربعاء (3)
                  filterDate={(d) =>
                    ![4, 5].includes(d.getDay()) && d >= new Date()
                  }
                  minTime={new Date(0, 0, 0, 17, 0)} // 5 مساءً
                  maxTime={new Date(0, 0, 0, 22, 0)} // 10 مساءً
                  locale="ar"
                  className="date-input"
                  calendarClassName="custom-calendar"
                />
                <style>
                  {`
                    .date-input {
                      width: 100%;
                      padding: 12px;
                      border-radius: 8px;
                      border: 1px solid #555;
                      background: rgba(255,255,255,0.1);
                      color: #fff;
                      font-size: 15px;
                      outline: none;
                    }
                    .date-input:focus {
                      border-color: #9fd87a;
                      box-shadow: 0 0 4px rgba(159, 216, 122, 0.4);
                    }
                    .custom-calendar {
                      font-family: 'Cairo', sans-serif;
                    }

                    @media (max-width: 768px) {
                      section {
                        padding: 60px 0;
                      }
                    }
                  `}
                </style>
              </div>

              <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
                style={{
                  background: "linear-gradient(90deg, #9fd87a, #6fb652)",
                  border: "none",
                  padding: "14px",
                  borderRadius: "10px",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "16px",
                  cursor: "pointer",
                  marginTop: "10px",
                }}
              >
                تأكيد الحجز
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hagz;
